var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrowUpRight = function SvgArrowUpRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.187 3.25c.311 0 .562.25.562.562v5.625a.561.561 0 1 1-1.125 0V5.169L4.21 10.585a.562.562 0 0 1-.795-.795L8.83 4.378l-4.268-.003A.56.56 0 0 1 4 3.812c0-.312.25-.563.562-.563z"
  })));
};
export default SvgArrowUpRight;